import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SEOHead from "@/components/SEOHead";
import SEORelatedPages from "@/components/SEORelatedPages";
import { getSEOData } from "@/lib/seo-pages";

const seo = getSEOData("/pesnya-pro-druga")!;

const faqItems = [
  { q: "Можно ли добавить смешные факты про друга?", a: "Конечно! Чем больше деталей — тем круче получится песня. Прозвища, истории, привычки — всё идёт в дело." },
  { q: "Друг узнает, что песня про него?", a: "Да, текст создаётся персонально — с его именем, историями и деталями из вашей дружбы." },
  { q: "Сколько времени занимает создание?", a: "Обычно не более 3 минут — от ввода истории до готовой демоверсии." },
  { q: "Можно ли выбрать стиль песни?", a: "Да — доступны поп, рок, рэп, шансон, электро и другие жанры." },
  { q: "Можно ли включить песню на вечеринке?", a: "Конечно. Полная версия скачивается в высоком качестве — включайте на колонке, отправляйте в чат." },
];

const PesnyaProDruga = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead title={seo.title} description={seo.description} canonical={seo.canonical} jsonLd={{ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqItems.map((item) => ({ "@type": "Question", name: item.q, acceptedAnswer: { "@type": "Answer", text: item.a } })) }} />
      <Navbar />
      <main className="pt-24 pb-16">
        <article className="container px-4 mx-auto max-w-3xl">
          <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold mb-6 text-foreground leading-tight">
            Песня про друга на заказ — удиви лучшего друга персональным хитом
          </h1>

          <div className="space-y-4 text-muted-foreground leading-relaxed mb-10">
            <p>У каждой дружбы есть история, которую невозможно рассказать открыткой. Как вы познакомились на первом курсе и сразу поняли — это надолго. Как он спас вам жизнь на сплаве (ну, почти). Как вы каждый Новый год смотрите один и тот же фильм.</p>
            <p>Вы вводите эти истории в HitChef. Выбираете стиль — может, дерзкий рэп или ироничный рок. Через три минуты звучит <strong className="text-foreground">песня, в которой каждая строчка — про вашего друга</strong>.</p>
            <p>Он слушает. Сначала смеётся. Потом замолкает. Потом говорит: «Бро, это лучший подарок в моей жизни».</p>
          </div>

          <div className="my-10 text-center">
            <Button size="lg" className="shadow-soft rounded-full px-8 text-base" asChild>
              <Link to="/create">🔥 Создать песню про друга</Link>
            </Button>
            <p className="text-muted-foreground text-sm mt-3">Демоверсия бесплатна. Без установки приложений.</p>
          </div>

          <section className="mb-12">
            <h2 className="font-display text-xl sm:text-2xl font-bold mb-4 text-foreground">Зачем дарить песню другу?</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>Подарки другу — это всегда головная боль. Носки? Обидится. Деньги? Неловко. Сертификат? Забудет.</p>
              <p>А теперь представьте: на <Link to="/pesnya-na-den-rozhdeniya" className="text-primary hover:underline">дне рождения</Link> или <Link to="/pesnya-dlya-vecherinki" className="text-primary hover:underline">вечеринке</Link> вы включаете песню. Все слышат знакомые истории. Друг — в центре внимания. Гости — в восторге.</p>
              <ul className="space-y-2 mt-4">
                <li>😂 Можно вспомнить самые смешные моменты вашей дружбы</li>
                <li>🎉 Включить на празднике — все гости будут подпевать</li>
                <li>❤️ Показать, что друг вам по-настоящему дорог</li>
                <li>🎁 Удивить <Link to="/originalnyi-podarok" className="text-primary hover:underline">оригинальностью</Link> — такого подарка точно ни у кого нет</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h3 className="font-display text-lg sm:text-xl font-bold mb-3 text-foreground">«Весь бар встал и аплодировал»</h3>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>Дима и Серёга дружат с восьмого класса. На тридцатилетие Серёги Дима написал историю: как они угнали школьный мел, как Серёга впервые влюбился в физичку, как вместе ездили автостопом на море.</p>
              <p>Выбрал стиль — весёлый рок с гитарой. В баре, когда зазвучала песня, Серёга сначала не понял. Потом услышал своё имя. Потом — историю про мел. Весь бар слушал молча. А когда песня закончилась — встали и захлопали.</p>
              <p>Серёга до сих пор ставит эту песню, когда собирается компания.</p>
            </div>
          </section>

          <div className="my-10 text-center">
            <Button size="lg" className="shadow-soft rounded-full px-8 text-base" asChild>
              <Link to="/create">🎵 Подарить другу незабываемый момент</Link>
            </Button>
            <p className="text-muted-foreground text-sm mt-3">Без регистрации. Без приложений.</p>
          </div>

          <section className="mb-12">
            <h2 className="font-display text-xl sm:text-2xl font-bold mb-4 text-foreground">Какой стиль выбрать?</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>Стиль песни задаёт настроение. Выбирайте то, что ближе вашему другу:</p>
              <ul className="space-y-2">
                <li>🎤 <strong className="text-foreground">Весёлый рэп</strong> — для энергичного друга, который любит движ</li>
                <li>🎸 <strong className="text-foreground">Рок-баллада</strong> — для настоящего бро с характером</li>
                <li>🎵 <strong className="text-foreground">Поп-хит</strong> — универсальный вариант, который понравится всем</li>
                <li>😂 <strong className="text-foreground">Шуточная песня</strong> — чтобы вся компания покатилась со смеху</li>
                <li>🎹 <strong className="text-foreground">Романтичная баллада</strong> — если хотите сказать «спасибо за дружбу» серьёзно</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-display text-xl sm:text-2xl font-bold mb-4 text-foreground">Как создать песню про друга?</h2>
            <ol className="space-y-3 text-muted-foreground list-decimal list-inside leading-relaxed">
              <li><strong className="text-foreground">Нажмите «Создать хит»</strong> — откроется простая форма</li>
              <li><strong className="text-foreground">Выберите событие и жанр</strong> — день рождения, вечеринка, или просто так</li>
              <li><strong className="text-foreground">Расскажите о друге</strong> — имя, прозвища, смешные истории, приколы</li>
              <li><strong className="text-foreground">Получите демоверсию</strong> — бесплатно, за 3 минуты</li>
            </ol>
            <p className="text-muted-foreground mt-4">Чем больше деталей — тем точнее и смешнее получится песня. Не стесняйтесь писать всё!</p>
          </section>

          <section className="mb-12">
            <h2 className="font-display text-xl sm:text-2xl font-bold mb-6 text-foreground">Часто задаваемые вопросы</h2>
            <Accordion type="single" collapsible className="space-y-2">
              {faqItems.map((item, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border border-border rounded-xl px-5 bg-card">
                  <AccordionTrigger className="text-left hover:no-underline text-sm font-medium text-foreground">{item.q}</AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-sm leading-relaxed">{item.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </section>

          <div className="my-10 text-center">
            <Button size="lg" className="shadow-soft rounded-full px-8 text-base" asChild>
              <Link to="/create">🎶 Пусть ваша дружба зазвучит</Link>
            </Button>
            <p className="text-muted-foreground text-sm mt-3">Персональная песня — подарок, который друг не забудет никогда.</p>
          </div>

          <SEORelatedPages pages={seo.relatedPages || []} />
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default PesnyaProDruga;
